import menu from '../../assets/MENU.jpg'

const GeneralMenuBar = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: '#170024',
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      {/* Ambient glow top */}
      <div
        style={{
          position: "fixed",
          top: "-120px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "600px",
          height: "300px",
          background: "radial-gradient(ellipse at center, rgba(200,100,255,0.18) 0%, transparent 70%)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Ambient glow bottom */}
      <div
        style={{
          position: "fixed",
          bottom: "-100px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "500px",
          height: "250px",
          background: "radial-gradient(ellipse at center, rgba(255,60,180,0.12) 0%, transparent 70%)",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Menu image */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: "680px",
          touchAction: "pinch-zoom",
        }}
      >
        <img
          src={menu}
          alt="Afrodise Bar Menu"
          style={{
            width: "100%",
            display: "block",
            borderRadius: "12px",
            touchAction: "pinch-zoom",
          }}
        />
      </div>
    </div>
  );
};

export default GeneralMenuBar;
